module.exports = __webpack_public_path__ + "img/jo.7b014113.svg";